// define a mixin object
export default {
  methods: {
    // action - clicked on, visited etc.
    // value - div id, link id, url etc.
    maClick (action, value) {
      this.$ma.trackEvent({
        action: `${action} clicked - ${value}`,
        properties: {
          value: value
        }
      })
    }
  }
}
